export default __webpack_public_path__ + "static/media/Wang-Qiang.48092cfa.png";